var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBitKeepLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 258,
    height: 290,
    fill: "none",
    viewBox: "0 0 258 290",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#7524F9",
    fillRule: "evenodd",
    d: "M257.1 81.7v14.5c0 2.9-1.5 5.5-4 6.9l-46.9 27.1 41.9 24.1c5.6 3.2 9 9.2 9 15.6v38.8c0 6.4-3.4 12.4-9 15.6L138 287.5c-5.6 3.2-12.4 3.2-18 0l-36.1-20.8c-2.7-1.5-2.7-5.4 0-6.9l119-68.5c1.3-.8 1.3-2.7 0-3.5l-44.2-25.5c-2.5-1.4-5.5-1.4-8 0L29.8 232c-1.8 1.1-4.1 1.1-6 0l-13.7-7.8C4.5 221 1 215 1 208.6v-15.9c0-2.1 1.1-4.1 3-5.2l173.3-99.6c1.3-.8 1.3-2.7 0-3.5L133 58.8c-2.5-1.4-5.5-1.4-8 0L6.9 126.7c-2.7 1.5-6-.4-6-3.5V81.6c0-6.4 3.4-12.4 9-15.6L120 2.8c5.6-3.2 12.4-3.2 18 0l109.9 63.4c5.8 3.1 9.2 9.1 9.2 15.5Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitKeepLogo);
export default __webpack_public_path__ + "static/media/bitKeepLogo.4e09433a08951b1c07ec9c9d82961bec.svg";
export { ForwardRef as ReactComponent };